import { ProfileAvatarConnected } from "PFApp/components/profile_avatar_connected";
import { Inline } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { getProfileName } from "PFCore/helpers/profile";

import { ShortlistWithScores } from "../types";
import css from "./suggested_wm_cell.module.scss";

type SuggestedWmCellProps = {
  shortlist: ShortlistWithScores;
};

export const SuggestedWmCell = ({ shortlist }: SuggestedWmCellProps) => {
  const { profile } = shortlist;
  return (
    <Inline alignItems="center" className={css.root}>
      <ProfileAvatarConnected profile={profile} size={24} />
      <Typography withMargin variant="labelBold" title={getProfileName(profile)} textOverflow="clip">
        {getProfileName(profile)}
      </Typography>
    </Inline>
  );
};
